import { Box } from "@mui/material";
import React from "react";
import { PlanoButton, PlanoTypography } from "../../Common";

import Cookies from "js-cookie";

const StoreRankCard = ({
  storeRank,
  rank,
  text,
  downloadButton = false,
  downloadBtnFunction,
}) => {
  const loc = Cookies.get("ssp_loc");

  return (
    <Box
      width={"134px"}
      height={"128px"}
      borderRadius={"16px"}
      bgcolor={"#EFEFEF"}
      textAlign={"center"}
      position={"relative"}
      p={1}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <PlanoTypography
          css={{
            fontSize: "30px",
            fontWeight: "600",
            lineHeight: "36px",
          }}
        >
          {rank}
        </PlanoTypography>
        <PlanoTypography
          css={{
            fontSize: "12px",
            fontWeight: "600",
            lineHeight: "16px",
          }}
        >
          {text || "Store Rank"}
        </PlanoTypography>
        {downloadButton && (
          <PlanoButton
            dissable={Number(rank) <= 0 ? true : false}
            mainfunction={() => {
              downloadBtnFunction(loc);
            }}
            css={{
              width: "89px",
              height: "23px",
              borderRadius: "7px",
              bgcolor:
                Number(rank) <= 0
                  ? "lightgrey !important"
                  : "#f04e23 !important",
              ":hover": { backgroundColor: "#f04e23 !important" },
              color:
                Number(rank) <= 0 ? "black !important" : "white !important",
              fontSize: "12px",
            }}
          >
            Download
          </PlanoButton>
        )}
      </Box>
    </Box>
  );
};

export default StoreRankCard;
